const ONE_SECOND_IN_MILLIS = 1_000;
const ONE_MINUTE_IN_MILLIS = ONE_SECOND_IN_MILLIS * 60;
const ONE_HOUR_IN_MILLIS = ONE_MINUTE_IN_MILLIS * 60;
const ONE_DAY_IN_MILLIS = ONE_HOUR_IN_MILLIS * 24;
const ONE_WEEK_IN_MILLIS = ONE_DAY_IN_MILLIS * 7;

const SHORT_STYLE_LOCALES = ['ja'];
const SPECIAL_LOCALES: Record<string, string> = {
  tl: 'tl-ph',
  zh: 'zh-tw',
  no: 'nb',
};

export const getDateLocale = (language: string) =>
  SPECIAL_LOCALES[language] || language;

export const isMoreThanWeekBefore = (time: Date) => {
  const lastWeek = new Date().getTime() - ONE_WEEK_IN_MILLIS;
  return new Date(time).getTime() < lastWeek;
};

export const getRelativeDateTime = (language = 'en', time: Date): string => {
  const rtf = new Intl.RelativeTimeFormat(language, {
    numeric: 'auto',
    style: SHORT_STYLE_LOCALES.includes(language) ? 'narrow' : 'long',
  });

  const now = Date.now();
  const diff = Number(time) - now;

  const units = [
    { max: ONE_MINUTE_IN_MILLIS, value: 0, name: 'second' },
    { max: ONE_HOUR_IN_MILLIS, value: ONE_MINUTE_IN_MILLIS, name: 'minute' },
    { max: ONE_DAY_IN_MILLIS, value: ONE_HOUR_IN_MILLIS, name: 'hour' },
    { max: ONE_WEEK_IN_MILLIS, value: ONE_DAY_IN_MILLIS, name: 'day' },
  ];

  for (const unit of units) {
    if (Math.abs(diff) < unit.max) {
      return rtf.format(
        unit.name === 'second' ? unit.value : Math.round(diff / unit.value),
        unit.name as Intl.RelativeTimeFormatUnit,
      );
    }
  }
  return '';
};

export const getDateTime = (language = 'en', time: Date): string => {
  const rtf = new Intl.DateTimeFormat(language, {
    day: 'numeric',
    month: 'short',
  });

  return rtf.format(time);
};

export const getHourAgo = () =>
  new Date(new Date().getTime() - ONE_HOUR_IN_MILLIS);

export const getDayAgo = () =>
  new Date(new Date().getTime() - ONE_DAY_IN_MILLIS);
